import Helper from './Helper';

class SideNav {
  constructor() {
    this.areas = Array.prototype.slice.call(document.querySelectorAll('div.ns-frontpage-component'));

    if(this.areas.length > 0){
      this.currentNumber = document.querySelector('.js-sidenav-number-current');
      this.totalNumber = document.querySelector('.js-sidenav-number-total');
      this.prevButton = document.querySelector('.js-sidenav-prev');
      this.nextButton = document.querySelector('.js-sidenav-next');
      
      if(this.prevButton && this.nextButton){
        this.totalNumber.innerText = String(this.areas.length);
        this.index = 0;
        this.setIndex();
        this.getIndex();
        this.bindButtons();
        this.bindScrolling();
      }
    }
  }

  bindButtons() {
    this.nextButton.addEventListener( 'click', e => {
      e.preventDefault();
      if(this.index < this.areas.length - 1) {
        this.areas[this.index + 1].scrollIntoView( {
          behavior: "smooth"
        });
      }
    });
    this.prevButton.addEventListener( 'click', e => {
      e.preventDefault();
      if(this.index > 0) {
        this.areas[this.index - 1].scrollIntoView( {
          behavior: "smooth"
        });
      }
    });
  }
  
  bindScrolling() {
    window.onscroll = () => {
      this.getIndex();

      let offsetVar =
        window.scrollY + 
        document.querySelector('.wp-sidenav').offsetHeight/2 + 
        window.innerHeight/2 + 60;

      let offsetAn =  document.querySelector('footer').offsetTop;

      let offsetTarget = offsetAn - offsetVar;
      
      if(offsetTarget <= 0) {
        document.querySelector('.wp-sidenav').style.marginTop = offsetTarget + "px";        
      } else {
        document.querySelector('.wp-sidenav').style.marginTop = "0px";    
      }
    } 
  }

  setIndex() {
    let i = 0;
    this.areas.forEach(area => {
      area.dataset.index = i;
      i++;
    });
  }


  getIndex() {
    const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
    for ( let section in this.areas ) {
      if ( this.areas[section].offsetTop <= scrollPos ) {
        this.index = parseInt(this.areas[section].dataset.index);
        this.currentNumber.innerText = this.index + 1;
      }
    }
  }
  
}

export default SideNav;
